export class EventApplicationService {
    constructor(eventGateway) {
        this.eventGateway = eventGateway;
    }
    sentEvent(event) {
        return this.eventGateway.sendEvent(event);
    }
    sentEvents(events) {
        return Promise.all(events.map(event => this.sentEvent(event)))
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
}
